(function($){
    $(function(){
        var $bbSlider = $('.zn-billboard-slider > .zn-stage');

        if ($bbSlider.length) {
            $bbSlider.each(function() {
                var $this = $(this),
                    currentSlide = 1,
                    slider = $this.sudoSlider({
                        continuous:true,
                        responsive:true,
                        auto:false,
                        autoHeight:true,
                        speed:500,
                        numeric:true,
                        prevNext:true,
                        moveCount: 1,
                        slideCount: 1,
                        initCallback: function () {
                            slider.getSlide(currentSlide).addClass('zn-active');

                            var $controls = slider.next('.controls');
                            
                            slider.find('ul').attr('aria-live', 'polite').attr('role', 'region');

                            $controls.find('.prevBtn').attr('aria-label', 'Navigate to previous slide').attr('title', 'Previous Slide');
                            $controls.find('.nextBtn').attr('aria-label', 'Navigate to next slide').attr('title', 'Next Slide');;

                            $controls.find('ol li a').each(function(){
                                var $this = $(this),
                                    target = $this.parent('li').attr('data-target');

                                $this.attr('aria-label', 'Navigate to slide ' + target).attr('title', 'Slide ' + target);
                            });
                        },
                        beforeAnimation: function (t) {
                            slider.getSlide(currentSlide).removeClass('zn-active');
                            slider.getSlide(t).addClass('zn-active');
                        },
                        afterAnimation: function (t) {
                            currentSlide = t;     
                        }
                      });

                
            });
        }
    });
})($JQ);